import React from 'react';
import { useSelector } from 'react-redux';
import { CSVLink } from 'react-csv';

import { useTranslation } from 'react-i18next';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import SaveIcon from '@material-ui/icons/SaveAltSharp';

import pushToGTM, { EXPORT_BOM_GA4_TAG } from '../../utils/analytics/gtm';
import { BOM_TABLE_COLS, BOM_CSV_HEADER } from './constants';
import Table from '../Table';
import TableSkeleton from '../Table/TableSkeleton';
import { adobeDownloadBom } from '../../utils/analytics/adobe/adob';
import { cleanupHtmlFromString } from '../OperatingValues/utils';
import { localDownloadBom } from '../../utils/analytics/local';
import BlurWrapper from '../BlurWrapper';

const BomTable = ({ logIn }) => {
	const { t } = useTranslation();
	const bomItems = useSelector(state => state.selectedDesign.detail.bom);
	const icPartNumber = useSelector(state => state.selectedDesign.icPartNumber);
	const designId = useSelector(state => state.selectedDesign.myDesign.id);
	const progressActive = useSelector(state => state.tabbar.progressActive);
	const inputParametersDL = useSelector(state => state.designList.inputParameters);
	const userLoggedIn = useSelector(state => state.user.loggedIn);

	const prepareCsvData = () =>
		bomItems.map(bomItem => ({
			...bomItem,
			part: cleanupHtmlFromString(bomItem.part),
			attributes: bomItem.attributes.map(attribute => cleanupHtmlFromString(attribute.formatted)).join(', '),
			description:
				bomItem.description.split('?').length > 1
					? bomItem.description
							.split('?')
							.slice(1)
							.map(part => (isNaN(part) ? t(`components.bom.desc.${part}`) : part))
							.join(' ')
					: bomItem.description
		}));

	const handleCsvDownload = () => {
		localDownloadBom(icPartNumber, inputParametersDL);
		adobeDownloadBom(icPartNumber, inputParametersDL);
		pushToGTM(EXPORT_BOM_GA4_TAG);
	};

	return progressActive ? (
		<TableSkeleton numberOfRows={bomItems.length} />
	) : (
		<Table
			id="BOM__table"
			title={t('components.bom.title')}
			actions={
				<BlurWrapper isBlurred={!userLoggedIn} showLoginButton={false}>
					<Tooltip title={t('components.bom.downloadCsv')}>
						<CSVLink
							data={prepareCsvData()}
							headers={BOM_CSV_HEADER}
							filename={'WebDesigner+ ' + designId + ' - ' + icPartNumber + ' bom.csv'}
							onClick={handleCsvDownload}>
							<IconButton aria-label="Download CSV">
								<SaveIcon />
							</IconButton>
						</CSVLink>
					</Tooltip>
				</BlurWrapper>
			}
			columns={BOM_TABLE_COLS}
			items={bomItems}
			withTotalRow
			logIn={logIn}
		/>
	);
};

export default BomTable;
